module.exports = __webpack_public_path__ + "static/media/success-icon.45bc2f74.svg";